module.exports = __webpack_public_path__ + "static/cancel_24px.3b35d9bc.svg";